/* ============================================================
   Marquee 310 — play/pause control
   The marquee scrolls via a CSS `animation` that never ends, so it needs an
   explicit pause control (WCAG 2.2.2 "Pause, Stop, Hide"). The CSS-only
   :hover pause doesn't count — it's unreachable by keyboard and touch.
   Toggling data-paused on the marquee flips animation-play-state.
   ============================================================ */

(function () {
  'use strict';

  function bind(btn) {
    if (btn.__marqueeControlsReady) return;
    const marquee = btn.closest('[data-marquee]');
    if (!marquee) return;
    btn.__marqueeControlsReady = true;

    btn.addEventListener('click', function () {
      const paused = marquee.getAttribute('data-paused') !== 'true';
      marquee.setAttribute('data-paused', paused ? 'true' : 'false');
      // Theme convention (section-shoppable-video.css): the modifier names the STATE,
      // and --play is what HIDES the play icon. Same classes video-controls.js uses.
      btn.classList.toggle('shoppable-video__control-button--play', !paused);
      btn.classList.toggle('shoppable-video__control-button--pause', paused);
      const label = paused ? marquee.dataset.labelPlay : marquee.dataset.labelPause;
      if (label) btn.setAttribute('aria-label', label);

      // A swapped aria-label isn't reliably re-announced, so also speak the resulting state.
      const status = marquee.querySelector('[data-marquee-status]');
      if (status) status.textContent = paused ? status.dataset.textPaused : status.dataset.textPlaying;
    });
  }

  function init() {
    document.querySelectorAll('[data-marquee-toggle]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', init);
})();
